"use strict";
exports.__esModule = true;
exports.getCookie = exports.setCookie = void 0;
function setCookie(cookieName, cookieValue) {
    var d = new Date();
    d.setTime(d.getTime() + 1 * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";").concat(expires);
}
exports.setCookie = setCookie;
function getCookie(cookieName) {
    var name = cookieName;
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return false;
}
exports.getCookie = getCookie;
